import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/transaction-report/download",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const userListing =
            require("./TransactionWiseReportDownload").default;
          cb(null, userListing);
        },
        "TransactionWiseReportDownload"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/TransactionWiseReportDownload/index.js